import { LucideIcon } from "lucide-react";
import { Card } from "../../../ui/card";

interface StatsCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  trend?: string;
  variant?: "default" | "success" | "warning" | "primary";
}

export const StatsCard = ({ title, value, icon: Icon, trend, variant = "default" }: StatsCardProps) => {
  const variantStyles = {
    default: "bg-white text-[#0071bd]",
    success: "bg-[#28a745] text-white",
    warning: "bg-[#ff9800] text-white",
    primary: "bg-[#0071bd] text-white",
  };

  return (
  <Card className={`p-6 ${variantStyles[variant]} border-0 shadow-lg animate-scale-in hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium opacity-90">{title}</p>
          <h3 className="text-3xl font-bold mt-2">{value}</h3>
          {trend && (
            <p className="text-xs mt-2 opacity-75">{trend}</p>
          )}
        </div>
        <div className={`p-4 rounded-2xl bg-white/30`}>
          <Icon className={`w-8 h-8 ${variant === "primary" ? "text-white" : variant === "success" ? "text-white" : variant === "warning" ? "text-white" : "text-[#0071bd]"}`} />
        </div>
      </div>
    </Card>
  );
};
